import React, { useState, ReactNode, useEffect } from 'react'
import { ScrollView, XStack, YStack, Theme, Anchor, Paragraph, useMedia } from '@my/ui'
import { color } from '@my/util'
import { MyHeader, NavMenu } from './LayoutComponents'
import { SidebarStateContext } from 'app/provider'
import './style.scss'

export const Layout: React.FC<{ children: ReactNode; showNav?: boolean }> = ({ children, showNav }) => {
  const media = useMedia()
  const currentYear = new Date().getFullYear();
  const whichSidebar = media['max-sm'] ? 'mobile' : 'desktop'
  const [isVisible, setIsVisible] = useState<{ mobile: boolean; desktop: boolean }>({
    mobile: false,
    desktop: true,
  })

  function handlePress() {
    const current = isVisible[whichSidebar]
    setIsVisible({ ...isVisible, [whichSidebar]: !current })
  }

  return (
    <>
      <style>{`body { background-color: rgb(133, 193, 157); }`}</style>
      <YStack display="flex" minHeight="100vh">
        <SidebarStateContext.Provider value={{which: whichSidebar, isVisible}}>
          <MyHeader handlePress={handlePress} showIcon={showNav} />
          <XStack flexGrow={1} alignItems="stretch" backgroundColor="#85C19D">
            {showNav && (
              <NavMenu
                isVisible={isVisible[whichSidebar]}
                closeFn={() => setIsVisible({ ...isVisible, [whichSidebar]: false })}
              />
            )}
            <YStack style={{ flex: 1 }} bg="white">
              {children}
              <Paragraph
                style={{
                  textAlign: 'center',
                  marginTop: 'auto',
                  padding: 8,
                  fontSize: 14,
                  lineHeight: 24,
                  fontWeight: 400,
                  color: 'rgb(102, 102, 102)', //color.darkNavy,
                  borderTopWidth: 1,
                  borderTopColor: 'rgba(220, 224, 229, .3)',
                  backgroundColor: '#fff'
                }}
              >
                {'©'+currentYear+' '}
                <Anchor
                  href="https://thezillennialadvisors.com/"
                  target="_blank"
                  fontSize={14}
                  lineHeight={24}
                  fontWeight={400}
                  color={'rgb(102, 102, 102)'}//{color.darkNavy}
                >
                  The Zillennial Advisors, LLC
                </Anchor>
              </Paragraph>
            </YStack>
          </XStack>
        </SidebarStateContext.Provider>
      </YStack>
    </>
  )
}

export const PublicLayout: React.FC<{ children: ReactNode; showNav?: boolean }> = ({ children, showNav }) => {
  const thisYear = new Date().getFullYear();
  const { sm } = useMedia()
  const whichSidebar = sm ? 'mobile' : 'desktop'
  const [isVisible, setIsVisible] = useState<{ mobile: boolean; desktop: boolean }>({
    mobile: false,
    desktop: true,
  })

  function handlePress() {
    const current = isVisible[whichSidebar]
    setIsVisible({ ...isVisible, [whichSidebar]: !current })
  }

  return (
    <YStack display="flex" minHeight="100vh">
        <MyHeader handlePress={handlePress} showIcon={false} showUserButton={false} />
        <YStack style={{ flexGrow: 1}} bg="white">
          {children}
          <Paragraph
            textAlign="center"
            marginTop="auto"
            p={8}
            fontSize={14}
            lineHeight={24}
            fontWeight={400}
            color={'#fff'}
            borderWidth={1}
            backgroundColor={'#85C19D'}
          >
            ©{thisYear+' '}
            <Anchor
              href="https://thezillennialadvisors.com/"
              target="_blank"
              fontSize={14}
              lineHeight={24}
              fontWeight={400}
              color={'#fff'}
            >
              The Zillennial Advisors, LLC
            </Anchor>
          </Paragraph>
        </YStack>
    </YStack>
  )
}